const constructTokenAmount = async (theapp, settings_entry, amount) => {
	console.log('constructPaymentLink called');

	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let context = {};
	await theapp.getCurrencyContext(context, settings_entry);

	let currency = context.currency;

	if (!currency)
	return Promise.reject('could not find currency');

	let amount_float = parseFloat(amount);
	let amount_decimals = 2; // assume monetary amount with 2 decimals
	let amount_string = amount_float.toFixed(amount_decimals); 
	
	// decimals
	let currency_decimals = currency.decimals;

	if (currency_decimals > amount_decimals) {
		for (var i = 0; i < currency_decimals-amount_decimals; i++)
		amount_string += '0';
	}

	let tokenamount = await mvcmywidget._getCurrencyAmountAlt(rootsessionuuid, currency.uuid, amount_string);
	let tokenamount_int = await tokenamount.toInteger();

	return tokenamount_int;
}

export default constructTokenAmount;